<div class="modal-container">
  <div mat-dialog-title
       class="modal-header">
    <h1 class="modal-title">{{ headerTitle }}</h1>
  </div>
  <form #form="ngForm"
        mat-dialog-content
        class="modal-content">

    <div class="fieldsetsContainer">
      <div class="fieldsetsGroup">

        <datex-common-form-field-shell label="Title"
                                       class="full">
          <input [(ngModel)]="params.title"
                 name="title"
                 required
                 maxlength="256"
                 class="datex-textbox" />
        </datex-common-form-field-shell>

        <datex-common-form-field-shell label="Description"
                                       class="full">
          <textarea [(ngModel)]="params.description"
                    name="description"
                    class="datex-textbox"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="10"></textarea>
        </datex-common-form-field-shell>
      </div>
    </div>
  </form>
  <div mat-dialog-actions
       class="modal-toolbar commands">
    <button mat-button
            [disabled]="!form.valid"
            class="datex-button primary"
            (click)="onSubmitClicked()">
      {{ submitLabel }}
    </button>
    <button mat-button
            class="datex-button secondary"
            (click)="onCancelClicked()">
      Cancel
    </button>
  </div>
</div>